var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivitiesSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 54H17H2V40M28 54H29H40V40M40 30V16H28M18 16H2V30",
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 54C25.6 54 25.5454 51.5607 26.5 50.874C28.0141 49.7848 29 48.0075 29 46C29 42.6863 26.3137 40 23 40C19.6863 40 17 42.6863 17 46C17 48.0075 17.9859 49.7848 19.5 50.874C20.5 51.5933 20.4 54 18 54",
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16C25.6 16 25.5454 13.5607 26.5 12.874C28.0141 11.7848 29 10.0075 29 8C29 4.68629 26.3137 2 23 2C19.6863 2 17 4.68629 17 8C17 10.0075 17.9859 11.7848 19.5 12.874C20.5 13.5933 20.4 16 18 16",
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 40C40 37.6 42.4393 37.5454 43.126 38.5C44.2152 40.0141 45.9925 41 48 41C51.3137 41 54 38.3137 54 35C54 31.6863 51.3137 29 48 29C45.9925 29 44.2152 29.9859 43.126 31.5C42.4067 32.5 40 32.4 40 30",
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 40C2 37.6 4.4393 37.5454 5.12605 38.5C6.21522 40.0141 7.99247 41 10 41C13.3137 41 16 38.3137 16 35C16 31.6863 13.3137 29 10 29C7.99247 29 6.21523 29.9859 5.12605 31.5C4.40668 32.5 2 32.4 2 30",
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitiesSelected);
export default __webpack_public_path__ + "static/media/activitiesSelected.f0ed5cb3.svg";
export { ForwardRef as ReactComponent };